import React, { FC, useCallback, useContext, useEffect } from 'react';
import { Typography, Icon, Divider, Button } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';
import styles from './styles.module.scss';
import { Form } from './components/form';
import cn from 'classnames';
import { extendFormStore } from '../../../store/reducers/formStore';
import { useDispatch } from 'react-redux';
import { useMainSkeleton } from '../../../store/reducers/selection';
import { StepContext } from '../creator/step.context';

const { Heading } = Typography;

export const FocusedView: FC = () => {
    const dispatch = useDispatch();
    const { mainSkeletonIsActive } = useMainSkeleton();
    const { setFocusedField, setShowLanding, currentStepConfig } = useContext(StepContext);

    useEffect(() => {
        dispatch(extendFormStore({ autoRun: false }));
        return () => {
            setFocusedField(null);
        };
    }, []);

    const onBackBtnClick = useCallback(() => {
        if (setShowLanding) {
            setShowLanding(true);
        }
    }, [setShowLanding]);

    if (mainSkeletonIsActive || !currentStepConfig) {
        return null;
    }

    return (
        <div className={styles['form-container']}>
            <div className={styles['form-header']}>
                <Button variant="text" onClick={onBackBtnClick} className={styles['form-header__btn']}>
                    <Icon size={20} icon={<ArrowLeft />} />
                </Button>
                <Heading level={3} className={styles['form-header__text']}>
                    Заявка на кредит
                </Heading>
            </div>
            <Divider className={styles['form-divider']} />
            <Form className={cn(styles['form-card'])} />
        </div>
    );
};
